export default class Modal {
  constructor(id) {
    this.id = id
    this.isVisible = false
    this.props = undefined
  }

  static MODAL_STAGE_REPORT = 1
  static MODAL_STREAK_PROGRESS = 2
  static MODAL_TOOL = 3

  show(props) {
    this.isVisible = true
    this.props = props
  }

  hide() {
    this.isVisible = false
  }
}